import { EntryItem, Link } from '@com-delta-omnichannel/aura';
import { Categories } from '../models/aem/overview.interface';
import { CurrentYearDashboardEntity } from '../models/api/earns-summary.interfaces';
import { getActivityEntryItem } from './earns-summary.utils';

export const addDefaultCard = (
  activity: CurrentYearDashboardEntity,
  defaultCard: EntryItem[],
  categoryCode: string
): EntryItem[] => {
  if (defaultCard.length === 1 && activity.categoryCode === categoryCode) {
    return defaultCard;
  }
  return [];
};

export const addDefaultAmexCard = (
  activity: CurrentYearDashboardEntity,
  defaultCard: EntryItem[],
  categoryCode: string,
  category: Categories
): EntryItem[] => {
  let activityValues: EntryItem[] = [];
  if (categoryCode === 'AXS' && category.type === 'NO-CARD-US') {
    activityValues = addDefaultCard(activity, defaultCard, 'AXS');
    return activityValues;
  }
  return [];
};

export const addDefaultJapanCard = (
  activity: CurrentYearDashboardEntity,
  defaultCard: EntryItem[],
  categoryCode: string,
  category: Categories
): EntryItem[] => {
  let activityValues: EntryItem[] = [];
  if (categoryCode === 'JPN' && category.type === 'NO-CARD-JPN') {
    activityValues = addDefaultCard(activity, defaultCard, 'JPN');
    return activityValues;
  }
  return [];
};

export const addCardActivity = (
  activity: CurrentYearDashboardEntity,
  addedActivity: EntryItem[],
  categoryCode: string,
  category: Categories
): EntryItem[] => {
  if (
    activity.categoryCode === categoryCode &&
    ('balanceAmt' in activity.categorySummarizedBalances[0] ||
      activity.cardTypeCode === category.type)
  ) {
    return addedActivity;
  }
  return [];
};

export const addOtherActivity = (
  activity: CurrentYearDashboardEntity,
  addedActivity: EntryItem[]
): EntryItem[] => {
  const categoryCodes = ['AXS', 'JPN'];
  if (!categoryCodes.includes(activity.categoryCode)) {
    return addedActivity;
  }
  return [];
};

export const checkCard = (
  category: Categories,
  activity: CurrentYearDashboardEntity,
  index: number
): EntryItem[] => {
  let addRecord: EntryItem[] = [];
  addRecord = getActivityEntryItem(category, activity, index);

  return addRecord;
};

export const getActionDetail = (
  label: string,
  url: string,
  id: string
): Link => {
  return { label, url, id };
};

export const getDefaultCardWithId = (
  defaultAmexCard: EntryItem[],
  categoryDetail: string,
  index: number
): EntryItem[] => {
  if (defaultAmexCard.length > 0) {
    defaultAmexCard[0] = {
      ...defaultAmexCard[0],
      id: `${categoryDetail}_${index}`
    };
  }
  return defaultAmexCard;
};
